import {locateAnchor} from './domain.js';
import {locateWikiAnchor} from './wikitext.js';
// A moved exact quote remains valid. Missing or ambiguous text must not guess.
export function quoteLocation(term,anchor,english){
 if(!anchor || anchor.field==='page')return '';
 if(anchor.field==='english')return anchor.version===english?.revision?'':'引用來自較早英文版本，請查看英文來源。';
 const wiki=term.contentFormat==='wikitext-v1'&&['wikitext','article','definition','body'].includes(anchor.field);
 const found=wiki?locateWikiAnchor(term.wikitext||'',anchor):locateAnchor(term[anchor.field]||'',anchor);
 return found?'':'原文已變更或無法唯一定位，引用仍保留。';
}
